// Apertura WhatsApp dallo staff/admin.
// "web"  → https://wa.me    (browser / WhatsApp Web: comportamento originale, default)
// "app"  → whatsapp://send  (apre l'app WhatsApp installata; opzionale, con ripiego su wa.me se non risponde)
const KEY = "wa_open_mode_v2";
export const WA_MODES = [["web", "Browser / WhatsApp Web (consigliato)"], ["app", "App WhatsApp installata"]];
export const getWaMode = () => localStorage.getItem(KEY) || "web";
export const setWaMode = (m) => localStorage.setItem(KEY, m);

export const waDigits = (phone) => {
  let p = (phone || "").replace(/\D/g, "");
  if (p.startsWith("00")) p = p.slice(2);
  if ((p.length === 10 || p.length === 9) && p.startsWith("3")) p = "39" + p;
  return p;
};

const parse = (urlOrPhone, text) => {
  if (/^https?:\/\//.test(urlOrPhone || "")) {
    try {
      const u = new URL(urlOrPhone);
      if (!/wa\.me|whatsapp\.com/.test(u.hostname)) return null;
      return { digits: (u.pathname + (u.searchParams.get("phone") || "")).replace(/\D/g, ""), msg: u.searchParams.get("text") || "" };
    } catch { return null; }
  }
  return { digits: waDigits(urlOrPhone), msg: text || "" };
};

export function waHref(urlOrPhone, text) {
  const p = parse(urlOrPhone, text);
  if (!p) return urlOrPhone;
  if (getWaMode() === "web") return `https://wa.me/${p.digits}${p.msg ? `?text=${encodeURIComponent(p.msg)}` : ""}`;
  return `whatsapp://send?${p.digits ? `phone=${p.digits}&` : ""}text=${encodeURIComponent(p.msg)}`;
}

export const isWaScheme = (href) => (href || "").startsWith("whatsapp:");

export const waWebHref = (urlOrPhone, text) => {
  const p = parse(urlOrPhone, text);
  return p ? `https://wa.me/${p.digits}${p.msg ? `?text=${encodeURIComponent(p.msg)}` : ""}` : urlOrPhone;
};

// Launch the installed app; if nothing reacts (app missing / scheme blocked) fall back to wa.me.
// `win` is an optional window already opened on user gesture, used for the fallback.
export function launchWaScheme(href, webHref, win) {
  let left = false;
  const gone = () => { left = true; };
  window.addEventListener("blur", gone, { once: true });
  document.addEventListener("visibilitychange", gone, { once: true });
  window.location.href = href;
  setTimeout(() => {
    window.removeEventListener("blur", gone);
    document.removeEventListener("visibilitychange", gone);
    if (left || document.visibilityState === "hidden" || !document.hasFocus()) { if (win) win.close(); return; }
    if (win) win.location = webHref; else window.open(webHref, "_blank", "noopener,noreferrer");
  }, 1800);
}

export function openWhatsApp(urlOrPhone, text) {
  const href = waHref(urlOrPhone, text);
  if (isWaScheme(href)) launchWaScheme(href, waWebHref(urlOrPhone, text));
  else window.open(href, "_blank", "noopener,noreferrer");
}

// Props per <a>: con lo schema app niente target=_blank (eviterebbe una scheda vuota)
export const waAnchorProps = (urlOrPhone, text) => {
  const href = waHref(urlOrPhone, text);
  return isWaScheme(href) ? { href } : { href, target: "_blank", rel: "noopener noreferrer" };
};
